// Cache Manager - Force fresh content on version updates

const APP_VERSION = '2.0.1' // Update this when you want to force cache clear
const VERSION_KEY = 'app_version'

export function checkAndClearOldCache() {
  const storedVersion = localStorage.getItem(VERSION_KEY)
  
  if (storedVersion !== APP_VERSION) {
    console.log('🔄 New app version detected, clearing old cache...')
    
    // Clear localStorage
    const keysToPreserve = ['hasSeenTutorial', 'lgpdConsent'] // Preserve important user preferences
    const preserved: Record<string, string> = {}
    
    keysToPreserve.forEach(key => {
      const value = localStorage.getItem(key)
      if (value) preserved[key] = value
    })
    
    localStorage.clear()
    
    // Restore preserved keys
    Object.entries(preserved).forEach(([key, value]) => {
      localStorage.setItem(key, value)
    })
    
    // Clear sessionStorage
    sessionStorage.clear()
    
    // Update version
    localStorage.setItem(VERSION_KEY, APP_VERSION)
    
    // Clear browser cache via Cache API
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          console.log('Deleting cache:', name)
          caches.delete(name)
        })
      })
    }
    
    // Unregister old service workers
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          console.log('Unregistering old service worker')
          registration.unregister()
        })
      })
    }
    
    console.log('✅ Cache cleared successfully!')
    
    // Force hard reload after a short delay
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }
}

// Call this on app initialization
export function initCacheManager() {
  // Check version on load
  checkAndClearOldCache()
  
  // Add cache-busting to dynamic imports
  if (import.meta.hot) {
    import.meta.hot.on('vite:beforeUpdate', () => {
      console.log('🔥 Hot reload detected, ensuring fresh content...')
    })
  }
}
